export const handleWidth = size => {
  switch (size) {
    case 'sm':
      return '60px';
    case 'md':
      return '90px';
    case 'lg':
      return '156px';
    default:
      return '90px';
  }
};

export const handleFontSize = size => {
  switch (size) {
    case 'sm':
      return '18px';
    case 'md':
      return '24px';
    case 'lg':
      return '28px';
    default:
      return '23px';
  }
};
